import { setUsrAppRefreshParams } from '@jfs/network'
import { Box, Spacer } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { AepsButton } from '../../comps/AepsButton'
import { Container } from '../../comps/Container'
import { OtpTextInput } from '../../comps/OtpTextInput'
import { ResendOtp } from '../../comps/ResendOtp'
import { SubTitle } from '../../comps/SubTitle'
import { Title } from '../../comps/Title'
import { useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { AppHeaderTransformer, extendAppSession } from '../../network/ExtendAppSession'
import { HeaderTransformer, extendUserSession } from '../../network/ExtendUserSession'
import { AadhaarNoBanner } from './AadhaarNoBanner'

export const EnterAadhaarOTPScreen = () => {
  const navigation = useNavigation()
  const route: any = useRoute()
  const isFromEnterAadhaarCardScreen = route.params?.isFromEnterAadhaarCardScreen

  const {
    maskedAadhaarCardNumber,
    generateOtpApi,
    maskedMobileNo,
    userAccessToken,
    userRefreshToken,
    appAccessToken,
    appRefreshToken,
    clientId,
    CHANNEL_ID,
    mobileNO,
  } = useStores((root) => ({
    maskedAadhaarCardNumber: root.agent.getMaskedAadhaarCardNumber(),
    generateOtpApi: root.agent.generateOtpApi,
    maskedMobileNo: root.agent.getMaskedMobileNo(),
    userAccessToken: root.agent.session.userAccessToken,
    userRefreshToken: root.agent.session.userRefreshToken,
    appAccessToken: root.agent.session.appAccessToken,
    appRefreshToken: root.agent.session.appRefreshToken,
    clientId: root.agent.CLIENT_ID,
    CHANNEL_ID: root.agent.session.CHANNEL_ID,
    mobileNO: root.agent.agentInfo.agentUserLoginId,
  }))
  const [lazyGenerateOtpApi, generateOtpApiHandler] = useLazyApiData(generateOtpApi)

  const [otp, setOtp] = useState('')

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'AADHAAR Verification' })
  }, [navigation])

  useEffect(() => {
    lazyGenerateOtpApi()
  }, [lazyGenerateOtpApi])

  useEffect(() => {
    if (generateOtpApiHandler.state === 'fulfilled') {
      setOtp('')
    }
  }, [generateOtpApiHandler.state])

  const onOtpSubmit = () => {
    navigation.navigate(Screens.SCAN_FINGERPRINT as never, { otp, isFromEnterAadhaarCardScreen } as never)
  }

  useEffect(() => {
    setUsrAppRefreshParams(
      extendUserSession(userAccessToken, userRefreshToken, CHANNEL_ID, mobileNO),
      HeaderTransformer,
      extendAppSession(appAccessToken, appRefreshToken, clientId, CHANNEL_ID),
      AppHeaderTransformer,
    )
  }, [userAccessToken, userRefreshToken, appAccessToken, appRefreshToken, CHANNEL_ID, clientId, mobileNO])

  return (
    <Container isLoading={generateOtpApiHandler.state === 'pending'} paddingTop={0} showFooter={true}>
      {!isFromEnterAadhaarCardScreen && maskedAadhaarCardNumber && (
        <AadhaarNoBanner aadhaarNo={maskedAadhaarCardNumber} />
      )}
      <Box f={1} overflow={'scroll'} paddingTop={32} alignItems="center">
        <Title title={'Please enter your 6-digit AADHAAR OTP'} />
        <Spacer size={8} />
        <SubTitle
          subTitle={`A 6-digit one time password is sent to your AADHAAR registered mobile number (${maskedMobileNo}).`}
        />
        <Spacer size={30} />
        <OtpTextInput fieldName="otp" value={otp} setFieldValue={(_, val: any) => setOtp(val)} />
        <ResendOtp
          onResendOTPPress={() => {
            lazyGenerateOtpApi()
          }}
        />
      </Box>
      <AepsButton title={'Verify'} onPress={onOtpSubmit} disabled={otp.length != 6} />
    </Container>
  )
}
